<template>
  <v-container fluid>
    <v-snackbar v-model="snackbar" :color="snackbarColor" :top="true" :right="true" :timeout="6000" absolute>
      {{ message }}
      <v-btn dark text @click="snackbar = false">
        CLOSE
      </v-btn>
    </v-snackbar>
    <v-row>
      <v-col cols="12">
        <v-card min-height="530">
          <v-card-title>
            <v-row>
              <v-col cols="4" md="2">
                <v-btn color="#7BC243" @click="openCreateDialog" class="white--text cataloguebtn"
                  v-if="$can('CAN_CREATE_CHARGE')"> New Warehouse Charge </v-btn>
              </v-col>
              <v-spacer></v-spacer>
              <v-col cols="6" md="4">
                <v-text-field v-model="search" append-icon="search" label="Search" single-line hide-details
                  color="primary"></v-text-field>
              </v-col>
            </v-row>
          </v-card-title>
          <v-card-text>
            <v-data-table :headers="headers" :items="warehousecharges" class="elevation-1" :search="search"
              disable-pagination :hide-default-footer="true">
              <template v-slot:[`header.dssWarehouseSettlementDetail.name`]="{ header }">
                <span class="font-weight-black primary--text"> {{ header.text.toUpperCase() }} </span>
              </template>
              <template v-slot:[`header.brokerCode`]="{ header }">
                <span class="font-weight-black primary--text"> {{ header.text.toUpperCase() }} </span>
              </template>
              <template v-slot:[`header.millerCode`]="{ header }">
                <span class="font-weight-black primary--text"> {{ header.text.toUpperCase() }} </span>
              </template>
              <template v-slot:[`header.growerCode`]="{ header }">
                <span class="font-weight-black primary--text"> {{ header.text.toUpperCase() }} </span>
              </template>
              <template v-slot:[`header.currency`]="{ header }">
                <span class="font-weight-black primary--text"> {{ header.text.toUpperCase() }} </span>
              </template>
              <template v-slot:[`header.unitofMeasure`]="{ header }">
                <span class="font-weight-black primary--text"> {{ header.text.toUpperCase() }} </span>
              </template>
              <template v-slot:[`header.creationDate`]="{ header }">
                <span class="font-weight-black primary--text"> {{ header.text.toUpperCase() }} </span>
              </template>
              <template v-slot:[`header.expiryDate`]="{ header }">
                <span class="font-weight-black primary--text"> {{ header.text.toUpperCase() }} </span>
              </template>
              <template v-slot:[`header.bagRate`]="{ header }">
                <span class="font-weight-black primary--text"> {{ header.text.toUpperCase() }} </span>
              </template>

              <template v-slot:[`header.pocketRate`]="{ header }">
                <span class="font-weight-black primary--text"> {{ header.text.toUpperCase() }} </span>
              </template>
              <template v-slot:[`header.gracePeriod`]="{ header }">
                <span class="font-weight-black primary--text"> {{ header.text.toUpperCase() }} </span>
              </template>
              <template v-slot:[`header.dayBagRate`]="{ header }">
                <span class="font-weight-black primary--text"> {{ header.text.toUpperCase() }} </span>
              </template>
              <template v-slot:[`header.status`]="{ header }">
                <span class="font-weight-black primary--text"> {{ header.text.toUpperCase() }} </span>
              </template>
              <template v-slot:[`item.actions`]="{ item }">
                <v-menu offset-y>
                  <template v-slot:activator="{ on }">
                    <v-btn color="primary" v-on="on" text icon class="actions">
                      <v-icon class="secondary--text"> more_horiz </v-icon>
                    </v-btn>
                  </template>
                  <v-list>
                    <v-list-item @click="approveChargeDialog(item)" v-if="$can('CAN_APPROVE_CHARGE')">
                      <v-list-item-title> Approve </v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="declineChargeDialog(item)" v-if="$can('CAN_APPROVE_CHARGE')">
                      <v-list-item-title> Reject </v-list-item-title>
                    </v-list-item>
                    <v-list-item>
                      <v-list-item-title @click="viewItem(item)"> View </v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </template>
            </v-data-table>

          </v-card-text>
          <v-card-actions>
            <v-row>
              <v-col cols="12" sm="9">
                <v-pagination v-model="page" :length="totalPages" total-visible="7" next-icon="mdi-menu-right"
                  prev-icon="mdi-menu-left" @input="handlePageChange"></v-pagination>
              </v-col>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
    <v-dialog v-model="createDialog" max-width="600px" persistent>
      <v-card>
        <v-card-title>
          <span class="headline">Create Warehouse Charge</span>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-xl fluid>
            <v-form ref="form" v-model="valid" lazy-validation>
              <v-layout wrap>
                <!-- <v-flex xs3>
                  <v-autocomplete name="warehouseId" v-model="charge.warehouseId" :items="warehouse" item-text="name"
                    item-value='warehouseId' label="Warehouse" v-validate="'required'"
                    :error-messages="errors.collect('warehouseId')">
                    >
                  </v-autocomplete>
                </v-flex> -->
                <v-flex xs4>
                  <v-autocomplete name="brokerId" v-model="charge.brokerCode" :items="brokers" item-text="name"
                    item-value='brokerCode' label="Broker" v-validate="'required'"
                    :error-messages="errors.collect('brokerCode')">
                    >
                  </v-autocomplete>
                </v-flex>
                <v-flex xs4>
                  <v-autocomplete name="miller" v-model="charge.millerCode" :items="millers" item-text="name"
                    item-value='millerId' label="Miller" v-validate="'required'"
                    :error-messages="errors.collect('miller')">
                    >
                  </v-autocomplete>
                </v-flex>
                <v-flex xs4>
                  <v-autocomplete name="benefactor" v-model="charge.growerCode" :items="benefactors"
                    item-text="organisationName" item-value='organisationCode' label="Grower" v-if="benefactorsField"
                    v-validate="'required'"
                    :error-messages="errors.collect('benefactor')" >
                    >
                  </v-autocomplete>
                </v-flex>
                <v-flex xs3>
                  <v-autocomplete name="currency" v-model="charge.currency" :items="currencies" label="Currency" required>
                    >
                  </v-autocomplete>
                </v-flex>
                <v-flex xs3>
                  <v-autocomplete name="unitofMeasure" v-model="charge.unitofMeasure" :items="unitOfMeasures"
                    label="Units" required>
                  </v-autocomplete>
                </v-flex>
                <v-flex xs3>
                  <label for="contractstartdate">Contract Starts </label>
                  <input type="date" id="datepicker" label="Units" v-model="charge.creationDate" />
                </v-flex>
                <v-flex xs3>
                  <label for="contractenddate">Contract Ends</label>
                  <input type="date" id="datepicker" v-model="charge.expiryDate" />
                </v-flex>

                <v-flex xs4>
                  <label for="bagRate">Bag Rate</label>
                  <input type="number" id="bagRate" v-model="charge.bagRate" placeholder="0">
                </v-flex>
                <v-flex xs4>
                  <label for="pocketRate">Pocket Rate</label>
                  <input type="number" id="pocketRate" v-model="charge.pocketRate" placeholder="0">
                </v-flex>
                <v-flex xs4>
                  <label for="gracePeriod">Grace Period(Weeks)</label>
                  <input type="number" id="gracePeriod" v-model="charge.gracePeriod" placeholder="0">
                </v-flex>
                <v-flex xs6>
                  <label for="dayBagRate">Per Day Per Bag Charge</label>
                  <input type="number" id="dayBagRate" v-model="charge.dayBagRate" placeholder="0">
                  <input v-if="isHidden" type="hidden" v-model="charge.contractId" />
                  <input v-if="isHidden" type="hidden" v-model="charge.whChecker" />
                  <input v-if="isHidden" type="hidden" v-model="charge.nceApprover" />
                  <input v-if="isHidden" type="hidden" v-model="charge.coopApprover" />
                  <input v-if="isHidden" type="hidden" v-model="charge.warehouseApprover" />
                  <input v-if="isHidden" type="hidden" v-model="charge.lastUpdateDate" />
                  <input v-if="isHidden" type="hidden" v-model="charge.dateCreated" />
                  <input v-if="isHidden" type="hidden" v-model="charge.status" />
                </v-flex>
                <v-flex id="fileupload" xs6>
                  <label for="contract">Contract </label>
                  <input type="file" id="file" ref="file" v-on:change="handleFileUpload()" required>
                  <!-- <v-btn color="secondary" @click="uploadContract">
                    <v-icon>mdi-file-upload</v-icon> </v-btn> -->
                </v-flex>
              </v-layout>
            </v-form>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-btn color="primary" @click="closeCreateDialog"> Cancel </v-btn>
          <v-spacer> </v-spacer>
          <v-btn color="secondary" :disabled="isDisabled" @click.prevent="handleProcessWarehouse"> Create</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="viewDialog" max-width="600px" persistent>
      <v-card>
        <v-card-title>
          <span class="headline">View Warehouse Charge</span>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-xl fluid>
            <v-form ref="form" v-model="valid" lazy-validation>
              <v-layout wrap>
                <!-- <v-flex xs3>
                  <v-autocomplete name="warehouseId" v-model="charge.warehouseId" :items="warehouse" item-text="name"
                    item-value='warehouseId' label="Warehouse" v-validate="'required'"
                    :error-messages="errors.collect('warehouseId')">
                    >
                  </v-autocomplete>
                </v-flex> -->
                <v-flex xs4>
                  <v-autocomplete name="brokerId" v-model="vcharge.vbrokerCode" :items="this.vcharge.vbrokerCode"
                    item-text="name" item-value='brokerCode' label="Broker" v-validate="'required'"
                    :error-messages="errors.collect('brokerCode')">
                    >
                  </v-autocomplete>
                </v-flex>
                <v-flex xs4>
                  <v-autocomplete name="miller" v-model="vcharge.vmillerCode" :items="this.vcharge.vmillerCode"
                    item-text="name" item-value='millerId' label="Miller" v-validate="'required'"
                    :error-messages="errors.collect('miller')">
                    >
                  </v-autocomplete>
                </v-flex>
                <v-flex xs4>
                  <v-autocomplete name="benefactor" v-model="vcharge.vgrowerCode" :items="this.vcharge.vgrowerCode"
                    item-text="organisationName" item-value='organisationCode' label="Grower" v-if="benefactorsField"
                    required>
                    >
                  </v-autocomplete>
                </v-flex>
                <v-flex xs3>
                  <v-autocomplete name="currency" v-model="vcharge.vcurrency" :items="this.vcharge.vcurrency"
                    label="Currency" required>
                    >
                  </v-autocomplete>
                </v-flex>
                <v-flex xs3>
                  <v-autocomplete name="unitofMeasure" v-model="vcharge.vunitofMeasure"
                    :items="this.vcharge.vunitofMeasure" label="Units" required>
                  </v-autocomplete>
                </v-flex>
                <v-flex xs3>
                  <label for="contractstartdate">Contract Starts </label>
                  <input type="text" id="datepicker" label="Units" v-model="this.vcharge.vcreationDate" />
                </v-flex>
                <v-flex xs3>
                  <label for="contractenddate">Contract Ends</label>
                  <input type="text" id="datepicker" v-model="this.vcharge.vexpiryDate" />
                </v-flex>

                <v-flex xs4>
                  <label for="bagRate">Bag Rate</label>
                  <input type="number" id="bagRate" v-model="this.vcharge.vbagRate" placeholder="0">
                </v-flex>
                <v-flex xs4>
                  <label for="pocketRate">Pocket Rate</label>
                  <input type="number" id="pocketRate" v-model="this.vcharge.vpocketRate" placeholder="0">
                </v-flex>
                <v-flex xs4>
                  <label for="gracePeriod">Grace Period(Weeks)</label>
                  <input type="number" id="gracePeriod" v-model="this.vcharge.vgracePeriod" placeholder="0">
                </v-flex>
                <v-flex xs6>
                  <label for="dayBagRate">Per Day Per Bag Charge</label>
                  <input type="number" id="dayBagRate" v-model="this.vcharge.vdayBagRate" placeholder="0">
                  <input v-if="isHidden" type="hidden" v-model="this.vcharge.vcontractId" />
                  <input v-if="isHidden" type="hidden" v-model="this.vcharge.vwhChecker" />
                  <input v-if="isHidden" type="hidden" v-model="this.vcharge.vnceApprover" />
                  <input v-if="isHidden" type="hidden" v-model="this.vcharge.vcoopApprover" />
                  <input v-if="isHidden" type="hidden" v-model="this.vcharge.vwarehouseApprover" />
                  <input v-if="isHidden" type="hidden" v-model="this.vcharge.vlastUpdateDate" />
                  <input v-if="isHidden" type="hidden" v-model="this.vcharge.vdateCreated" />
                  <input v-if="isHidden" type="hidden" v-model="this.vcharge.vstatus" />
                </v-flex>
                <v-flex id="fileupload" xs6>
                  <label for="contract">Contract </label>
                  <input type="file" id="file" ref="file" v-on:change="handleFileUpload()" required>
                  <!-- <v-btn color="secondary" @click="uploadContract">
                    <v-icon>mdi-file-upload</v-icon> </v-btn> -->
                </v-flex>
              </v-layout>
            </v-form>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-btn color="primary" @click="closeViewDialog"> Cancel </v-btn>
          <v-spacer> </v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="approveDialog" max-width="600px" persistent>
      <v-card>
        <v-card-title class="body-2 accent--text font-weight-bold">Approve Charge</v-card-title>

        <v-card-text class="accent--text">
          Confirm approval of the warehouse charge
        </v-card-text>

        <v-card-actions>
          <v-btn color="secondary"
                class="accent--text logoutbtn" flat="flat" @click="closeApproveChargeDialog" >
            Cancel
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn color="#7BC243" class="white--text confirmbtn" @click="approveCharge">
            Approve
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="declineDialog" max-width="600px" persistent>
      <v-card>
        <v-card-title class="body-2 accent--text font-weight-bold">Decline Charge</v-card-title>

        <v-card-text class="accent--text">
          Confirm decline of warehouse charge
        </v-card-text>

        <v-card-actions>
          <v-btn color="secondary"
                class="accent--text logoutbtn" flat="flat" @click="closeDeclineChargeDialog" >
            Cancel
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn color="#7BC243" class="white--text confirmbtn" @click="declineCharge">
            Decline
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<script>
import axios from 'axios'
import config from '../../../config'
import { mapState, mapActions } from 'vuex'
import _ from 'lodash'
import moment from 'moment'

export default {
  name: 'WarehouseCharges',
  data: function () {
    return {
      createDialog: false,
      isDisabled:false,
      viewDialog: false,
      charge: {
        'brokerCode': '',
        'millerCode': '',
        'growerCode': '',
        'currency': '',
        'unitofMeasure': '',
        'creationDate': '',
        'expiryDate': '',
        'bagRate': '',
        'pocketRate': '',
        'gracePeriod': '',
        'dayBagRate': '',
        'contractId': Math.floor(Math.random() * 100000) + 1,
        'lastUpdateDate': new Date(),
        'dateCreated': new Date(),
        'whChecker': 'warehouse',
        'nceApprover': 'user_nce',
        'coopApprover': 'coop_checker',
        'warehouseApprover': 'warehouse',
        'nceApprover': 'user_nce'
      },
      vcharge: {
        'vbrokerCode': '',
        'vmillerCode': '',
        'vgrowerCode': '',
        'vcurrency': '',
        'vunitofMeasure': '',
        'vcreationDate': '',
        'vexpiryDate': '',
        'vbagRate': '',
        'vpocketRate': '',
        'vgracePeriod': '',
        'vdayBagRate': '',
        'vcontractId': Math.floor(Math.random() * 100000) + 1,
        'vlastUpdateDate': new Date(),
        'vdateCreated': new Date(),
        'vwhChecker': 'warehouse',
        'vnceApprover': 'user_nce',
        'vcoopApprover': 'coop_checker',
        'vwarehouseApprover': 'warehouse',
        'vnceApprover': 'user_nce'
      },

      file: '',
      benefactors: [],
      beneficiaries: [],
      currencies: [],
      millers: [],
      warehouse: [],
      brokers: [],
      unitOfMeasures: [],
      snackbarColor: '',
      message: '',
      brocker: '',
      brockerName: '',
      millerName: '',
      miller: '',
      grower: '',
      currency: '',
      unitofMeasure: '',
      contractStartDate: null,
      contractEndDate: null,
      currentDate: null,
      bagRate: 0,
      pocketRate: '',
      gracePeriod: '',
      perDayPerBagCharge: '',
      contract: '',
      snackbar: false,
      deductionValueRules: [
        v => !!v || 'Deduction value is required'
      ],
      nonMarketers: [],
      contractIdVal: null,
      marketers: [],
      valid: true,
      isHidden: true,
      fsc: [],
      bankorgs: [],
      statutoryorgs: [],
      benefactorsField: true,
      chargeSelected: {},
      approvedcharges: [],
      unapprovedcharges: [],
      charges: [],
      approveDialog: false,
      declineDialog: false,
      selectedWarehouseCharge: {},
      curUser: {},
      curUsers: {},
      curUserN: '',
      headers: [
        { text: 'Warehouse', value: 'dssWarehouseSettlementDetail.name' },
        { text: 'Brocker Code', value: 'brokerCode' },
        { text: 'Miller Code', value: 'millerCode' },
        { text: 'Grower Code', value: 'growerCode' },
        // { text: 'Currency', value: 'currency' },
        // { text: 'Units', value: 'unitOfMeasure' },
        // { text: 'StartDate', value: 'creationDate' },
        // { text: 'EndDate', value: 'expiryDate' },
        // { text: 'BagRate', value: 'bagRate' },
        // { text: 'PocketRate', value: 'pocketRate' },
        // { text: 'GracePeriod', value: 'gracePeriod' },
        // { text: 'DayBagRate', value: 'dayBagRate' },
        { text: 'Status', value: 'status.statusName' },
        { text: 'Actions', value: 'actions', sortable: false }
      ],
      search: '',
      page: 1,
      totalPages: 0,
      pageSize: 5,
      pageSizes: [5, 10],
      warehousecharges: []
    }
  },
  watch: {
    search: function (oldValue, newValue) {
      this.debouncedGetAnswer()
    }
  },
  mounted() {
    this.getLoggedInUser()
    this.isWarehouse()
    this.getCurrencies()
    this.getMillers()
    this.getWarehouse()
    this.getBrokers()
    this.getMeasureTypes()
    this.getFCS()
    this.getCharges()
  },
  computed: {
    ...mapState({ user: state => state.user }),
  },
  methods: {
    viewItem(item) {
      console.log('Warehouse Item -> ', item)
      this.viewDialog = true
      this.vcharge.vbrokerCode = item.brokerCode;
      this.vcharge.vmillerCode = item.millerCode;
      this.vcharge.vgrowerCode = item.growerCode;
      this.vcharge.vcurrency = item.currency;
      this.vcharge.vunitofMeasure = item.unitOfMeasure;
      this.vcharge.vcreationDate = this.getDateformated(item.creationDate);
      this.vcharge.vexpiryDate = this.getDateformated(item.expiryDate)
      this.vcharge.vbagRate = item.bagRate;
      this.vcharge.vpocketRate = item.pocketRate;
      this.vcharge.vgracePeriod = item.gracePeriod;
      this.vcharge.vdayBagRate = item.dayBagRate;
      this.vcharge.vcontractId = item.contractId
      this.vcharge.vlastUpdateDate = this.getDateformated(item.lastUpdateDate);
      this.vcharge.vdateCreated = this.getDateformated(item.dateCreated)
      this.vcharge.vwhChecker = item.whChecker
      this.vcharge.vnceApprover = item.nceApprover;
      this.vcharge.vcoopApprover = item.coopApprover;
      this.vcharge.vwarehouseApprover = item.warehouseApprover;
      this.vcharge.vnceApprover = item.nceApprover;

    },
    getLoggedInUser() {
      this.curUser = JSON.parse(JSON.stringify(localStorage.getItem("user")))
      this.curUsers = JSON.parse(this.curUser)
      console.log('User======>   ' + this.curUsers.firstName + ' ' + this.curUsers.lastName + ' ' + this.curUsers.username)
    },
    isWarehouse() {
      this.curUser = JSON.parse(JSON.stringify(localStorage.getItem("user")))
      this.curUsers = JSON.parse(this.curUser)
      if (this.curUsers.firstName === 'Warehouse' && this.curUsers.lastName === 'Warehouse' && this.curUsers.username === 'warehouse') {
        return false;
      } else {
        return true
      }
    },
    handleFileUpload() {
      this.file = this.$refs.file.files[0]
    },
    handleProcessWarehouse() {
      this.uploadContract();
      this.createCharge();
      // if (file.files.length === 0) {
      //   alert('Please select a file.');
      //   return;
      // } else {
      //   this.uploadContract();
      //   this.createCharge();
      // }
    },
    uploadContract() {
      if (this.$refs.form.validate()) {
        this.showProgressBar = true
        const url = config.serverURI + '/upload/catalogue/'
        const formData = new FormData()
        formData.append('file', this.file)

        axios({ url: url, method: 'POST', responseType: 'blob', data: formData })
          .then(response => {
            this.uploadFileDialog = false
            // if (response.data.error === false) {
            this.snackbar = true
            this.snackbarColor = 'primary'
            this.message = 'Success'
            // } else {
            //   this.message = 'Failed uploading'
            //   this.snackbar = true
            //   this.snackbarColor = 'error'
            // }

            this.getUploadedFiles()
          })
          .catch(error => {
            // console.log('error', error.response)
            if (error.response.status === 424) {
              this.message = 'Failed:: review  downloaded cataloguefile for errors'
              const url = window.URL.createObjectURL(new Blob([error.response.data], { type: 'application/vnd.ms-excel' }))
              const link = document.createElement('a')
              link.href = url
              const itemFileName = 'File_With_Error_' + this.file.name
              link.setAttribute('download', itemFileName)
              document.body.appendChild(link)
              link.click()
            } else {
              Common.blobToJson(error.response.data)
                .then(jsonData => {
                  this.message = typeof jsonData.message !== 'undefined' ? jsonData.message : error.response.status + ' Request failed'
                })
                .catch(error => {
                  console.error('Error:', error)
                  this.message = typeof error.response.data.message !== 'undefined' ? error.response.data.message : error.response.status + ': Error occurred'
                })
            }

            // this.message = typeof error.response.data.message !== 'undefined' ? error.response.data.message : error.response.status
            this.snackbar = true
            this.snackbarColor = 'error'
            this.uploadFileDialog = false
          })
          .finally(() => {
            this.showProgressBar = false
          })
        this.handleFileUpload()
      }
    },

    openCreateDialog() {
      this.createDialog = true
    },
    getCurrencies() {
      var url = config.serverURI + '/organization/currency'
      axios.get(url)
        .then(response => {
          if (response.status !== 200) {
            console.log('Error is ' + this.error)
            return
          }
          this.currencies = response.data
        })
        .catch(error => {
          console.log('error', error.response)
        })
    },
    generateRandomNumber() {
      this.charge.contractId = Math.floor(Math.random() * 100000) + 1;
    },
    getDateformated(val) {
      var date = new Date(val);
      var year = date.getFullYear();
      var month = ("0" + (date.getMonth() + 1)).slice(-2);
      var day = ("0" + date.getDate()).slice(-2);

      console.log(`${year}-${month}-${day}`);
      return `${day}-${month}-${year}`;
    },
    getMillers: function () {
      const url = config.serverURI + '/organization/getMillers'
      axios.post(url)
        .then(response => {
          this.millers = response.data
        })
        .catch(error => {
          this.$store.dispatch('alert/displayAlert', { snackbar: true, color: 'error', message: error.response.data ? error.response.data.message : 'Error ocurred' })
        })
      return this.organisations
    },
    getBrokerName(brockerId) {
      var url = config.serverURI + '/organization/getBrokers/' + brockerId
      axios.post(url)
        .then(response => {
          if (response.status !== 200) {
            console.log('Error is ' + this.error)
            return
          }
          this.brockerName = response.data.name
        })
        .catch(error => {
          console.log('error', error.response)
        })
      return this.brockerName
    },
    getBrokers() {
      var url = config.serverURI + '/organization/getBrokers'
      axios.post(url)
        .then(response => {
          if (response.status !== 200) {
            console.log('Error is ' + this.error)
            return
          }
          this.brokers = response.data
          // console.log('Brockers:====> ' + JSON.stringify(response.data))
        })
        .catch(error => {
          console.log('error', error.response)
        })
    },
    getWarehouse: function () {
      const url = config.serverURI + '/organization/getWarehouse'
      axios.post(url)
        .then(response => {
          this.warehouse = response.data
        })
        .catch(error => {
          this.$store.dispatch('alert/displayAlert', { snackbar: true, color: 'error', message: error.response.data ? error.response.data.message : 'Error ocurred' })
        })
      return this.organisations
    },
    brockerChanged() {
      const chargeNameSelected = this.charge.chargeType
      const chargeSelectedArr = this.chargeTypes.filter((charge) => charge.chargeName === chargeNameSelected)
      this.chargeSelected = chargeSelectedArr[0]
      if (this.chargeSelected.chargeType.id === 1) { // government
        this.benefactorsField = false
        this.beneficiaries = this.statutoryorgs
      } else if (this.chargeSelected.chargeType.id === 4) { // marketer
        this.benefactorsField = true
        this.benefactors = this.fcs
        this.beneficiaries = this.marketers
      } else if (this.chargeSelected.chargeType.id === 3) { // bank comissions
        this.benefactorsField = false
        this.beneficiaries = this.bankorgs
      } else { // contractual
        this.benefactors = this.fcs
        this.beneficiaries = this.nonMarketers
        this.benefactorsField = true
      }
    },
    showDate() {
      const dateObj = new Date();
      this.currentDate = dateObj.getDate() + "/" + dateObj.getMonth() + "/" + dateObj.getFullYear();
    },
    closeCreateDialog() {
      this.createDialog = false
      this.charge = {
        'broker': '',
        'miller': '',
        'grower': '',
        'currency': '',
        'unitOfMeasure': '',
        'creationDate': '',
        'expiryDate': '',
        'bagRate': '',
        'pocketRate': '',
        'gracePeriod': '',
        'perDayPerBagCharge': '',
        'contract': null
      }
      this.$refs.form.resetValidation()
    },
    closeViewDialog() {
      this.viewDialog = false
      this.vcharge = {
        'vbrokerCode': '',
        'vmillerCode': '',
        'vgrowerCode': '',
        'vcurrency': '',
        'vunitofMeasure': '',
        'vcreationDate': '',
        'vexpiryDate': '',
        'vbagRate': '',
        'vpocketRate': '',
        'vgracePeriod': '',
        'vdayBagRate': '',
        'vcontractId': '',
        'vlastUpdateDate': '',
        'vdateCreated': '',
        'vwhChecker': '',
        'vnceApprover': '',
        'vcoopApprover': '',
        'vwarehouseApprover': '',
        'vnceApprover': ''
      }
      this.$refs.form.resetValidation()
    },
    createCharge() {
      if (this.$refs.form.validate()) {
        this.createDialog = false
        const url = config.serverURI + '/charges/create/warehouse'
        // console.log('Payload :' + JSON.stringify(this.charge))
        axios.post(url, this.charge)
          .then(response => {
            // console.log(response.data)
            if (response.data.error !== false) {
              this.$store.dispatch('alert/displayAlert', { snackbar: true, color: 'error', message: response.data.message })
              return
            }
            this.getCharges()
            this.charge = {}
            this.$refs.form.resetValidation()
            this.$store.dispatch('alert/displayAlert', { snackbar: true, color: 'primary', message: response.data.message })
          })
          .catch(error => {
            this.$store.dispatch('alert/displayAlert', { snackbar: true, color: 'error', message: error.response.message })
          })
      }
    },
    getMarketers() {
      const url = config.serverURI + '/organization/get-marketers'
      axios.get(url)
        .then(response => {
          this.marketers = response.data
        })
        .catch(error => {
          this.$store.dispatch('alert/displayAlert', { snackbar: true, color: 'error', message: error.response.message })
        })
    },
    getNonMarketers() {
      const url = config.serverURI + '/organization/get-non-marketers'
      axios.get(url)
        .then(response => {
          this.nonMarketers = response.data
        })
        .catch(error => {
          this.$store.dispatch('alert/displayAlert', { snackbar: true, color: 'error', message: error.response.message })
        })
    },
    getFCS() {
      const url = config.serverURI + '/organization/get-fcs'
      axios.get(url)
        .then(response => {
          this.benefactors = response.data
        })
        .catch(error => {
          this.$store.dispatch('alert/displayAlert', { snackbar: true, color: 'error', message: error.response.message })
        })
    },
    getDeductionTypes() {
      const url = config.serverURI + '/charges/deductiontype'
      axios.get(url)
        .then(response => {
          this.deductionTypes = response.data
        })
        .catch(error => {
          this.$store.dispatch('alert/displayAlert', { snackbar: true, color: 'error', message: error.response.message })
        })
    },
    getMeasureTypes() {
      const url = config.serverURI + '/charges/chargemeasures'
      axios.get(url)
        .then(response => {
          this.unitOfMeasures = response.data
        })
        .catch(error => {
          this.$store.dispatch('alert/displayAlert', { snackbar: true, color: 'error', message: error.response.message })
        })
    },
    getBankOrgs() {
      const url = config.serverURI + '/organization/get-bank-org'
      axios.get(url)
        .then(response => {
          this.bankorgs = response.data
        })
        .catch(error => {
          this.$store.dispatch('alert/displayAlert', { snackbar: true, color: 'error', message: error.response.message })
        })
    },
    getChargeTypes() {
      const url = config.serverURI + '/charges/charges'
      axios.get(url)
        .then(response => {
          this.chargeTypes = response.data
        })
        .catch(error => {
          this.$store.dispatch('alert/displayAlert', { snackbar: true, color: 'error', message: error.response.message })
        })
    },
    getStatutoryOrgs() {
      const url = config.serverURI + '/organization/get-statutory-org'
      axios.get(url)
        .then(response => {
          this.statutoryorgs = response.data
        })
        .catch(error => {
          this.$store.dispatch('alert/displayAlert', { snackbar: true, color: 'error', message: error.response.message })
        })
    },
    getRequestParams(name, page, pageSize) {
      const params = {}
      if (page) {
        params.page = page - 1
      }
      if (pageSize) {
        params.size = pageSize
      }
      if (name) {
        params.benefactorName = name
      }
      return params
    },
    handlePageChange(value) {
      this.page = value
      this.getCharges()
    },
    handlePageSizeChange(size) {
      this.pageSize = size
      this.page = 1
      this.getCharges()
    },
    getCharges() {
      const params = this.getRequestParams(this.search, this.page, this.pageSize)
      const url = config.serverURI + '/charges/warehouse'
      axios.get(url, { params })
        .then(response => {
          const { items, totalPages } = response.data
          this.warehousecharges = items
          this.totalPages = totalPages
          // console.log('Response', items)
        })
        .catch(error => {
          this.$store.dispatch('alert/displayAlert', { snackbar: true, color: 'error', message: error.response.message })
        })
      // console.log('Warehouse Charges: ==>>', this.warehousecharges)
      return this.warehousecharges
    },
    approveChargeDialog(item) {
      //console.log('Items :  ===>'+ JSON.stringify(item))
      this.approveDialog = true
      this.selectedWarehouseCharge = item
    },
    declineChargeDialog(item) {
      this.declineDialog = true
      this.selectedWarehouseCharge = item
    },
    closeApproveChargeDialog() {
      this.approveDialog = false
    },
    closeDeclineChargeDialog() {
      this.declineDialog = false
    },
    approveCharge() {
      const token = localStorage.getItem("token");
      const tokenconfig = { headers: { Authorization: `Bearer ${token}` } };
      const url = config.serverURI + '/charges/warehouse/approve'
      //  axios.post(url, this.selectedWarehouseCharge)
      axios.post(url, this.selectedWarehouseCharge, tokenconfig)
        .then(response => {
          this.closeApproveChargeDialog()
          this.getCharges()
          this.$store.dispatch('alert/displayAlert', { snackbar: true, color: 'primary', message: response.data.message })
        })
        .catch(error => {
          this.$store.dispatch('alert/displayAlert', { snackbar: true, color: 'error', message: error.response.message })
        })
    },
    declineCharge() {
      const url = config.serverURI + '/charges/decline'
      axios.post(url, this.selectedWarehouseCharge)
        .then(response => {
          this.closeDeclineChargeDialog()
          this.getCharges()
        })
        .catch(error => {
          this.$store.dispatch('alert/displayAlert', { snackbar: true, color: 'error', message: error.response.message })
        })
    }
  },
  created: function () {
    this.debouncedGetAnswer = _.debounce(this.getCharges, 1000)
  }
}

</script>
<style>
#fileupload {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.charge_box_empty {
  position: relative;
  background: #fff;
  border: 1px solid #707070;
}

.charge_box {
  position: relative;
  background: #fff;
  border: 1px solid #707070;
}

.charge_box:after,
.charge_box:before {
  right: 100%;
  top: 17%;
  border: solid transparent;
  content: " ";
  height: 0;
  width: 0;
  position: absolute;
  pointer-events: none;
}

.charge_box:after {
  border-color: rgba(255, 255, 255, 0);
  border-right-color: #fff;
  border-width: 20px;
  margin-top: -20px;
}

.charge_box:before {
  border-color: rgba(112, 112, 112, 0);
  border-right-color: #707070;
  border-width: 21px;
  margin-top: -21px;
}

.confirmbtn {
  font-weight: 700;
  border-radius: 8px;
}
</style>
